import { ArbeidsKortingRates } from './interface';

export const rates: ArbeidsKortingRates = {
    senior: {
        2018: [
            { to: 9_468, percentage: 0.901, base: 0, offset: 0 },
            { to: 20_450, percentage: 14.320, base: 86, offset: -9_468 },
            { to: 33_112, percentage: 0, base: 1_659, offset: 0 },
            { to: 123_362, percentage: -1.837, base: 1_659, offset: -33_112 }
        ],
        2019: [
            { to: 9_694, percentage: 0.898, base: 0, offset: 0 },
            { to: 20_940, percentage: 14.689, base: 88, offset: -9_694 },
            { to: 34_060, percentage: 0, base: 1_740, offset: 0 },
            { to: 90_710, percentage: -3.069, base: 1_740, offset: -34_060 },
        ],
        2020: [
            { to: 9_921, percentage: 1.464, base: 0, offset: 0 },
            { to: 21_430, percentage: 15.004, base: 146, offset: -9_921 },
            { to: 34_954, percentage: .862, base: 1_873, offset: -21_430 },
            { to: 98_604, percentage: -3.124, base: 1_989, offset: -34_954 },
        ],
        2021: [
            { to: 10_109, percentage: 2.371, base: 0, offset: 0 },
            { to: 21_836, percentage: 14.890, base: 240, offset: -10_109 },
            { to: 35_653, percentage: 1.378, base: 1_987, offset: -21_836 },
            { to: 105_737, percentage: -3.105, base: 2_178, offset: -35_653 },
        ],
        2022: [
            { to: 10_350, percentage: 2.348, base: 0, offset: 0 },
            { to: 22_357, percentage: 14.718, base: 244, offset: -10_350 },
            { to: 36_650, percentage: 1.349, base: 2_011, offset: -22_356 },
            { to: 109_347, percentage: -3.030, base: 2_204, offset: -36_649 },
        ],
        2023: [
            { to: 10_740, percentage: 4.241, base: 0, offset: 0 },
            { to: 22_357, percentage: 15.388, base: 457, offset: -10_740 },
            { to: 36_650, percentage: 1.589, base: 2_374, offset: -22_356 },
            { to: 115_295, percentage: -3.355, base: 2_604, offset: -37_691 },
        ],
        2024: [
            { to: 11_491, percentage: 4.346, base: 0, offset: 0 },
            { to: 24_821, percentage: 16.214, base: 501, offset: -11_490 },
            { to: 39_958, percentage: 1.275, base: 2_662, offset: -24_820 },
            { to: 124_935, percentage: -3.355, base: 2_854, offset: -39_957 },
        ]
    },
    nonSenior: {
        2018: [
            { to: 9_468, percentage: 1.764, base: 0, offset: 0 },
            { to: 20_450, percentage: 28.064, base: 167, offset: -9_468 },
            { to: 33_112, percentage: 0, base: 3_249, offset: 0 },
            { to: 123_362, percentage: -3.6, base: 3_249, offset: -33_112 }
        ],
        2019: [
            { to: 9_694, percentage: 1.754, base: 0, offset: 0 },
            { to: 20_940, percentage: 28.712, base: 170, offset: -9_694 },
            { to: 34_060, percentage: 0, base: 3_399, offset: 0 },
            { to: 90_710, percentage: -6, base: 3_399, offset: -34_060 },
        ],
        2020: [
            { to: 9_921, percentage: 2.812, base: 0, offset: 0 },
            { to: 21_430, percentage: 28.812, base: 279, offset: -9921 },
            { to: 34_954, percentage: 1.656, base: 35_95, offset: -21430 },
            { to: 98_604, percentage: -6, base: 3819, offset: -34954 },
        ],
        2021: [
            { to: 10_109, percentage: 4.581, base: 0, offset: 0 },
            { to: 21_836, percentage: 28.771, base: 463, offset: -10_109 },
            { to: 35_653, percentage: 2.663, base: 3_837, offset: -21_836 },
            { to: 105_737, percentage: -6, base: 4_205, offset: -35_652 },
        ],
        2022: [
            { to: 10_350, percentage: 4.541, base: 0, offset: 0 },
            { to: 22_357, percentage: 28.461, base: 470, offset: -10_350 },
            { to: 36_650, percentage: 2.610, base: 3_887, offset: -22_356 },
            { to: 10_9347, percentage: -5.860, base: 4_260, offset: -36_649 },
        ],
        2023: [
            { to: 10_740, percentage: 8.231, base: 0, offset: 0 },
            { to: 23_201, percentage: 29.861, base: 884, offset: -10_740 },
            { to: 37_691, percentage: 3.085, base: 4_605, offset: -23_201 },
            { to: 115_295, percentage: -6.510, base: 5_052, offset: -37_691 },
        ],
        2024: [
            { to: 11_491, percentage: 8.425, base: 0, offset: 0 },
            { to: 24_821, percentage: 31.433, base: 968, offset: -11_490 },
            { to: 39_958, percentage: 2.471, base: 5_158, offset: -24_820 },
            { to: 124_935, percentage: -6.510, base: 5_532, offset: -39_957 },
        ]
    }
};
